(function() {
  'use strict';

  angular.module('component.eventTypes')
    .component('eventTypesList', {
      templateUrl: 'app/components/event-types/list.html',
      controller: 'EventTypesController',
      controllerAs: 'eventTypesCtrl'
    });
})();
